/**
 * Formatting utilities
 */

export function formatPhone(phone) {
  if (!phone) return '';
  const match = phone.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  if (!match) return phone;
  return `(${match[1]}) ${match[2]}-${match[3]}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
    timeZone: 'America/New_York'
  });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    timeZone: 'America/New_York'
  });
}

export function formatRelative(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  const hrs = Math.floor(mins / 60);
  const days = Math.floor(hrs / 24);

  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  if (hrs < 24) return `${hrs}h ago`;
  if (days === 1) return 'yesterday';
  return `${days}d ago`;
}

export function daysInStage(updatedAt) {
  if (!updatedAt) return 0;
  return Math.floor((Date.now() - new Date(updatedAt).getTime()) / (1000 * 60 * 60 * 24));
}

export const STAGE_LABELS = {
  NEW: 'New',
  CONTACTED: 'Contacted',
  SCREENING: 'Screening',
  INTERVIEW_SCHEDULED: 'Interview Scheduled',
  INTERVIEWED: 'Interviewed',
  HIRED: 'Hired',
  ONBOARDING: 'Onboarding',
  REJECTED: 'Rejected',
  NO_SHOW: 'No Show',
  UNRESPONSIVE: 'Unresponsive'
};

export const STAGE_COLORS = {
  NEW: 'bg-blue-100 text-blue-800',
  CONTACTED: 'bg-yellow-100 text-yellow-800',
  SCREENING: 'bg-purple-100 text-purple-800',
  INTERVIEW_SCHEDULED: 'bg-indigo-100 text-indigo-800',
  INTERVIEWED: 'bg-orange-100 text-orange-800',
  HIRED: 'bg-green-100 text-green-800',
  ONBOARDING: 'bg-teal-100 text-teal-800',
  REJECTED: 'bg-red-100 text-red-800',
  NO_SHOW: 'bg-gray-100 text-gray-800',
  UNRESPONSIVE: 'bg-gray-100 text-gray-600'
};

export const SOURCE_LABELS = {
  indeed: 'Indeed',
  craigslist: 'Craigslist',
  gusto: 'Gusto',
  phone: 'Phone',
  direct: 'Direct',
  email: 'Email'
};

export const SOURCE_COLORS = {
  indeed: 'bg-blue-50 text-blue-700',
  craigslist: 'bg-purple-50 text-purple-700',
  gusto: 'bg-green-50 text-green-700',
  phone: 'bg-yellow-50 text-yellow-700',
  direct: 'bg-gray-50 text-gray-700',
  email: 'bg-red-50 text-red-700'
};
